<template>
  <div class="board">
    <!-- ✅ 상단 액션 영역 -->
    <div class="board-actions">
      <!-- <button type="button" class="btn-primary" @click="goCreate()"> -->
      <button type="button" class="btn-primary" @click="goCreate()">
        <i class="fa-solid fa-plus" aria-hidden="true"></i>
        <span>질문 등록</span>
      </button>
    </div>
    <table class="board-table" role="table">
      <colgroup>
        <col style="width: 96px" />
        <col />
        <col style="width: 160px" />
        <col style="width: 160px" />
        <col style="width: 120px" /> 
      </colgroup>

      <thead>
        <tr>
          <th scope="col">번호</th>
          <th scope="col">제목</th>
          <th scope="col">작성자</th>
          <th scope="col">등록일</th>
          <th scope="col">답변상태</th>
        </tr>
      </thead>

      <tbody>
        <!-- <tr>
          <td>118</td>
          <td class="cell-title">
            <a href="#" class="title-link" @click="go('/qnadetail')">뉴스레터 25년 8월호_Vol.101</a>
            <span class="badge-new" aria-label="새 글">N</span>
            <i class="fa-solid fa-lock file-mark" aria-hidden="true"></i>
          </td>
          <td>김민준</td>
          <td>2025-08-13</td>
        </tr> -->

        <tr v-for="(vo, index) in qnaList" :key="index" class="qna-wrap">
          <td>{{ vo.no }}</td>
          <td class="cell-title" @click="goToDetail(vo.questionId)">
            <span class="title-text">{{ vo.title }}</span>
            <i class="fa-solid fa-lock file-mark" aria-hidden="true"></i>
          </td>
          <td @click="goToDetail(vo.questionId)">{{vo.userName}}</td>
          <td>{{ vo.updatedAt.slice(0,10).replace('T',' ') }}</td>
          <!-- ✅ 답변 상태 -->
          <!-- <td>
            <span
              class="answer-badge"
              :class="answerStatusMap[vo.questionId] ? 'answer-badge--done' : 'answer-badge--wait'"
            >
              {{ answerStatusMap[vo.questionId] ? '답변완료' : '답변대기' }}
            </span>
          </td> -->
          <td>
            <span
              class="answer-badge"
              :class="vo.answerCount >= 1 ? 'answer-badge--done' : 'answer-badge--wait'"
            >
              {{ vo.answerCount >= 1 ? '답변완료' : '답변대기' }}
            </span>
          </td>
        </tr>

      </tbody>
    </table>
    <div class="pagination-wrapper">
      <Pagination
        id="pagination"
        class="pagination"
        v-if="userJson.pagination"
        :gridInfo="userJson"
        @getGridData="getGridData"
      />
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { ref, computed, onMounted, onUnmounted, watch } from 'vue'
import { useStore } from 'vuex'
import Pagination from '@/components/common/grid/pagination.vue'
import userJson from '@/models/gridInfo/user.json'
import { checkPassWord, answerList } from '@/api/qna'

const store = useStore()
const router = useRouter()
const searchText = ref('')
const searchCode = ref('all')
const searchParam = computed(() => store.state.temp.searchParam)
const qnaList = computed(() => store.state.grid.qnaData)
const checkUserId = computed(() => store.state.temp.userInfo)
const answerStatusMap = ref({})

// const goCreate = () => {
//   if(checkUserId.value.userId == ''){
//     alert("로그인이 필요한 서비스입니다.")
//     router.push({ name: 'login' })
//     return false
//   }
//   router.push({ name: 'qnaregister' })
// }
const goCreate = () => {
  router.push({ name: 'qnaregister' })
}

const getGridData = async () => {
  const param = {
    pageNo: searchParam.value.pageNo,
    countPerRecord: searchParam.value.countPerRecord,
    search: searchText.value,
    typeCd: searchCode.value
  }
  await store.dispatch('grid/qnaList', param)
}

const goToDetail = async (questionId) => {
  // ✅ 1. 비밀번호 입력 팝업 띄우기
  const password = window.prompt('비밀번호를 입력해주세요.')

  if (!password) return // 사용자가 취소했거나 빈 값 입력 시 종료

  // ✅ 2. 서버로 비밀번호 검증 요청
  const params = {
    questionId: questionId,
    password: password
  }

  try {
    const resultVo = await checkPassWord(params)

    if (resultVo?.result === 'ok') {
      // ✅ 3. 성공 시 상세 페이지로 이동
      router.push({
        name: 'qnadetail', // 실제 상세페이지 라우트 이름
        query: { questionId: questionId }
      })
    } else {
      alert(resultVo?.resultMsg || '비밀번호가 일치하지 않습니다.')
    }
  } catch (err) {
    console.error('비밀번호 확인 실패:', err)
    alert('비밀번호 확인 중 오류가 발생했습니다.')
  }
}

const fetchAnswerStatuses = async (list) => {
  const map = {}

  // 페이지당 목록만 병렬 조회
  await Promise.all(
    (list || []).map(async (vo) => {
      try {
        const res = await answerList({ questionId: vo.questionId })
        // data 배열이 있고, 그 안에 content(답변)가 있으면 완료 처리
        map[vo.questionId] = Array.isArray(res?.data) && res.data.some(a => !!a?.content)
      } catch (e) {
        // 실패하면 일단 대기 처리(화면 깨짐 방지)
        map[vo.questionId] = false
      }
    })
  )

  answerStatusMap.value = map
}

// qnaList가 갱신될 때마다 상태 맵 재생성
watch(
  qnaList,
  (newList) => {
    fetchAnswerStatuses(newList)
  },
  { immediate: true }
)



onMounted(() => getGridData())

onUnmounted(() => store.commit('temp/clearSearchParam'))
</script>


<style scoped>
.board { 
  max-width: 1200px;
  margin: 0 auto 50px;
}

/* ✅ 상단 액션: 오른쪽 정렬 */
.board-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 0 0 12px;
}

/* ✅ 기본_primary 버튼 */
.btn-primary {
  display: inline-flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  padding: 10px 16px;
  background: #1d2088;
  color: #fff;
  border-radius: 10px;
  font-weight: 800;
  border: 0;
  cursor: pointer;
}
.btn-primary:hover { filter: brightness(0.95); }
.btn-primary i { font-size: 14px; }
.btn-primary span { line-height: 1; }

.board-table {
  width: 100%;
  table-layout: fixed;
}

.board-table th,
.board-table td {
  padding: 14px 16px;
  border-bottom: 1px solid #e9ecef;
  font-size: 14px;
  line-height: 1.4;
}

.board-table thead th {
  background: #f8fafc;
  color: #0f172a;
  font-weight: 600;
  text-align: center;
}

.board-table tbody td {
  color: #111827;
  text-align: center;
}

.qna-wrap{
  cursor: pointer;
}


.board-table .cell-title {
  text-align: left;
  cursor: pointer;
  max-width: 400px; /* ✅ 필요에 따라 조정 (테이블 폭에 맞게) */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}

/* ✅ 제목 텍스트만 말줄임 적용 (아이콘은 제외) */
.board-table .cell-title .title-text {
  display: inline-block;
  max-width: calc(100% - 20px); /* 아이콘 영역 확보 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}

/* 제목 옆 작은 문서 아이콘 */
.board-table .file-mark {
  margin-left: 6px;
  font-size: 12px;
  color: #9ca3af;
  vertical-align: middle;
}
.board-table .title-link {
  display: inline-block;
  max-width: calc(100% - 40px); /* 배지+아이콘 공간 확보 */
  vertical-align: middle;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #0f172a;
}

/* 제목 옆 자물쇠 아이콘 */
/* .board-table .file-mark {
  margin-left: 8px;
  font-size: 12px;
  color: #9ca3af;
  vertical-align: middle;
} */

/* 새 글 배지 N */
.board-table .badge-new {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  padding: 0 6px;
  height: 18px;
  min-width: 18px;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  color: #fff;
  background: #ef4444; /* 눈에 띄는 레드 */
  border-radius: 9px;   /* pill */
  vertical-align: middle;
}

/* 행 호버 효과 */
.board-table tbody tr:hover { background: #f9fbff; }

/* 모바일: 컬럼 축약 (작성자/조회수 숨김) */
@media (max-width: 768px) {
  .board-table th:nth-child(3),
  .board-table td:nth-child(3),
  .board-table th:nth-child(5),
  .board-table td:nth-child(5) { display: none; }

  .board-table colgroup col:nth-child(3),
  .board-table colgroup col:nth-child(5) { display: none; }

  /* 모바일에서 제목 영역 여유 조금 더 */
  .board-table .title-link {
    max-width: calc(100% - 48px);
  }
}


.pagination-wrapper {
  display: flex;
  justify-content: center; /* 가로 가운데 */
  align-items: center;
  padding: 16px 0 0;       /* 테이블과 간격 */
}

/* ===== 답변 상태 배지 ===== */
.answer-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 72px;
  padding: 4px 10px;
  font-size: 13px;
  font-weight: 700;
  border-radius: 999px;
  border: 1px solid transparent;
}

/* 답변 대기 */
.answer-badge--wait {
  background: #f1f5f9;
  color: #64748b;
  border-color: #e2e8f0;
}

/* 답변 완료 */
.answer-badge--done {
  background: #eef0ff;   /* 메인 블루의 밝은 틴트 */
  color: #1d2088;        /* 메인 컬러 */
  border: 1px solid #c7cbff;
}

@media (max-width: 768px) {
  .board-table th:nth-child(4),
  .board-table td:nth-child(4) { display: none; }

  .board-table colgroup col:nth-child(4) { display: none; }
}


</style>
